import {
  REQUEST_CURRENT_USER_DETAILS,
  RECEIVE_CURRENT_USER_DETAILS,
} from '../constants/actionTypes';

export function reqCurrentUserDetails(id) {
  return {
    type: REQUEST_CURRENT_USER_DETAILS,
    id,
  };
}

export function receiveCurrentUserDetails(userDetails) {
  return {
    type: RECEIVE_CURRENT_USER_DETAILS,
    userDetails,
  };
}
